import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=7dd9a59a&scoped=true&lang=pug"
import script from "./OnboardingModal.vue?vue&type=script&lang=ts"
export * from "./OnboardingModal.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=7dd9a59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9a59a",
  null
  
)

export default component.exports